/* @ngInject */
function BackofficeBusinessDataController ($scope, $rootScope, $timeout, $translate, GeneralSettingsService, MessageService, ToastService, ModalService, UserService, BusinessDataService) {
  const getEditBusinessDataFieldController = () => import('../../dialogs/edit-business-data-field/edit-business-data-field-dialog.controller')
  $scope.context = null
  $scope.savingBdf = false
  const api = {
    _getUserContext,
    _setInitialData,
    _formatBusinessDataField,
    _sortTextsByLocale,
    _applyFieldTreatment,
    _swap
  }

  activate()
  async function activate () {
    const userContext = await api._getUserContext()
    const businessData = await BusinessDataService.getAllBusinessDataService()
    api._setInitialData({ context: userContext, businessData })
  }

  async function _getUserContext () {
    const userContexts = await UserService.getUserContexts()
    return userContexts?.length ? userContexts[0] : null
  }

  function _setInitialData (data) {
    const { context, businessData } = data
    $timeout(() => {
      $scope.context = {
        ...context,
        businessData: businessData.map(api._formatBusinessDataField)
      }
    })
  }

  function _formatBusinessDataField (field) {
    const texts = api._sortTextsByLocale(field.texts)
    if (field.options?.length) {
      field.options.map(api._formatBusinessDataField)
    }
    return {
      ..._applyFieldTreatment(field),
      texts
    }
  }

  function _sortTextsByLocale (texts) {
    const locale = $rootScope.oUser?.locale || 'PT-BR'
    return texts.sort(text => {
      if (text.locale === locale) {
        return -1
      }
      return 1
    })
  }

  function _applyFieldTreatment (oBusinessDataField) {
    if (oBusinessDataField.type === 'OPTION') return oBusinessDataField
    switch (oBusinessDataField.type) {
      case 'PHONE':
        oBusinessDataField.htmlType = 'TEL'
        break
      case 'PHONE_BR':
        oBusinessDataField.htmlType = 'TEL'
        break
      case 'DROPDOWN':
        oBusinessDataField.newValue = parseInt(oBusinessDataField.value)
        break
      default:
        oBusinessDataField.htmlType = oBusinessDataField.type
        break
    }
    return oBusinessDataField
  }

  function _swap (index, otherIndex, array) {
    const aux = array[index]
    array[index] = array[otherIndex]
    array[otherIndex] = aux
    return array
  }

  $scope.changeOrder = (index, newOrder) => {
    if (!newOrder) {
      return
    }
    $scope.context.businessData = api._swap(index, newOrder + index, $scope.context.businessData).map((field, order) => {
      field.order = order
      return field
    })
  }

  $scope.openBusinessDataFieldsModal = (field, name) => {
    const fieldSelect = $scope.context.businessData.filter(field => field.type === 'DROPDOWN')
    getEditBusinessDataFieldController().then(({ EditBusinessDataFieldController }) => {
      ModalService.showModal({
        autofocus: false,
        templateId: 'editBusinessDataField.html',
        templateUrl: '/admin/dialogs/edit-business-data-field/edit-business-data-field-dialog.html?$$REVISION$$',
        destroyable: true,
        controller: EditBusinessDataFieldController,
        closable: true,
        data: {
          oUser: $rootScope.oUser,
          field,
          reloadBusinessDataFields: activate,
          name,
          fieldSelect
        }
      })
        .then(success => {
          if (success) {
            ToastService.showSuccessToast($translate.instant('generalSettings.businessDataFields.successCreatedField'))
            activate()
          }
        })
        .catch(() => {
          ToastService.defaultErrorToast()
        })
    })
  }

  $scope.deleteField = id => {
    MessageService.warning({
      title: 'warning',
      text: 'removeBdf',
      cancelButton: 'no',
      confirmButton: 'yes',
      closeOnConfirm: true,
      press: function (shouldDelete) {
        if (shouldDelete) {
          BusinessDataService.deleteBusinessDataField(id)
            .then(() => {
              ToastService.showSuccessToast($translate.instant('generalSettings.businessDataFields.successDeletedField'))
              activate()
            })
            .catch((error) => {
              if (error.status === 409) {
                ToastService.showErrorToast($translate.instant('generalSettings.businessDataFields.fieldAttachedtoBriefing'))
              } else {
                ToastService.defaultErrorToast()
              }
            })
        }
      }
    })
  }

  $scope.createField = () => {
    const fieldsLength = $scope.context.businessData.length
    const lastFieldId = $scope.context.businessData.slice(-1)[0]?.id || 0
    const name = `${fieldsLength}-${lastFieldId}`
    $scope.openBusinessDataFieldsModal(null, name)
  }

  $scope.saveBdf = async () => {
    try {
      $scope.savingBdf = true
      // não sei pq diabos isso foi feito de forma separada, mas não é prioridade mexer nisso agora
      await GeneralSettingsService.updateEditableFields($scope.context.businessData)
      await GeneralSettingsService.updateOrderFields($scope.context.businessData)

      ToastService.defaultSuccessToast()
    } catch (error) {
      console.error(error)
      ToastService.defaultErrorToast()
    } finally {
      $scope.savingBdf = false
    }
  }

  $scope.resetBdf = () => {
    activate()
  }
}

export { BackofficeBusinessDataController }
